export interface IProductSubCategory {
  name: string;
  description: string;
  imgSrc?: string;
}

export interface IProductCategory {
  name: string;
  description: string;
  imgSrc: string;
  subCategories: IProductSubCategory[];
}

export const serviceCategoryInitialState: IProductCategory[] = [
  {
    name: "💉 BOOSTER SHOTS",
    description:
      "Highly targeted, fast-acting wellness injections designed to enhance your natural beauty, cellular health, and daily energy levels from the inside out.",
    imgSrc: require("../../assets/images/services/injection-1.jpeg"),
    subCategories: [
      {
        name: "💉 BOOSTER SHOTS",
        description: "",
      },
    ],
  },
  {
    name: "💉 DERMAL FILLERS",
    description:
      "The Dermal Fillers category features a highly personalized, medical-aesthetic treatment designed to sculpt, balance, and restore volume to the face with natural-looking results.",
    imgSrc: require("../../assets/images/services/injection-2.webp"),
    subCategories: [
      {
        name: "💉 DERMAL FILLERS",
        description: "",
      },
    ],
  },
  {
    name: "💧 IV THERAPY & INFUSIONS",
    description: "",
    imgSrc: require("../../assets/images/services/drip-1.png"),
    subCategories: [
      {
        name: "💧 IV THERAPY & INFUSIONS",
        description: "",
      },
    ],
  },
  {
    name: "🩺 AESTHETIC & WELLNESS CONSULTATION",
    description: "",
    imgSrc: "",
    subCategories: [
      {
        name: "🩺 AESTHETIC & WELLNESS CONSULTATION",
        description: "",
      },
    ],
  },
  {
    name: "BODY CONTOURING",
    description: "",
    imgSrc: "",
    subCategories: [
      {
        name: "BODY CONTOURING",
        description: "",
      },
    ],
  },
  {
    name: "BOTOX TREATMENTS",
    description: "",
    imgSrc: "",
    subCategories: [
      {
        name: "BOTOX TREATMENTS",
        description: "",
      },
    ],
  },
];
